import { datadogRum } from '@datadog/browser-rum';

import { logger } from '../../providers';
import { DATADOG_CONFIG } from '../../environment/datadog/config';
import { DATADOG_ERRORS } from './errors';

export const initialiseDatadogRum = (): void => {
  try {
    datadogRum.init(DATADOG_CONFIG);
  } catch (error) {
    logger.error(DATADOG_ERRORS.initialisation, error);
  }
};
